/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-mate.agent-details.created-by': 'Créé par',
  'ai-mate.agent-details.description': 'Description',
  'ai-mate.agent-details.instruction': 'Instruction',
  'ai-mate.agent-details.knowledge': 'Connaissances',
  'ai-mate.agent-details.name': 'Nom',
  'ai-mate.agent-form.agents-external-files.dropzone-area-text':
    'Glisser-déposer des fichiers pour les joindre ou les <link>parcourir</link>',
  'ai-mate.agent-form.agents-external-files.file-viewer.delete-action-label': 'Supprimer',
  'ai-mate.agent-form.cancel-button': 'Fermer',
  'ai-mate.agent-form.custom-prompt-helper-message': "Personnalisez l'invite pour cet agent",
  'ai-mate.agent-form.custom-prompt-input': 'Invite personnalisée',
  'ai-mate.agent-form.description-input': 'Description',
  'ai-mate.agent-form.error-agent-in-use':
    "Cet agent est actuellement utilisé par quelqu'un et ne peut pas être rendu privé pour le moment. Veuillez réessayer ultérieurement.",
  'ai-mate.agent-form.error-agent-name-exists': "Le nom de l'agent existe déjà. Veuillez en choisir un autre.",
  'ai-mate.agent-form.error-incorrect-owner':
    "Vous n'êtes pas propriétaire de cet agent et vous ne pouvez pas le modifier.",
  'ai-mate.agent-form.form-error': "Impossible d'enregistrer les changements",
  'ai-mate.agent-form.name-input': 'Nom',
  'ai-mate.agent-form.name-input-exists-error-message': 'Un agent portant ce nom existe déjà',
  'ai-mate.agent-form.publish-agent': 'Publier',
  'ai-mate.agent-form.publish-setting-button': "Plus d'options de publication",
  'ai-mate.agent-form.publish-setting-private': 'Moi uniquement',
  'ai-mate.agent-form.publish-setting-public': 'Tout le monde sur ce site',
  'ai-mate.agent-form.required-label': "Les champs obligatoires sont marqués d'un astérisque",
  'ai-mate.agent-form.spaces-select': 'Espaces',
  'ai-mate.agent-form.spaces-select-helper-message':
    "Sélectionnez des espaces permettant à l'agent de répondre aux questions avec un meilleur contexte",
  'ai-mate.agent-form.spaces-select-placeholder': "Recherche d'espaces…",
  'ai-mate.agent-form.title-create': 'Ajouter un nouvel agent',
  'ai-mate.agent-form.title-edit': "Modifier l'agent « {agentName} »",
  'ai-mate.agent-list.close-button': 'Fermer',
  'ai-mate.agent-list.create-agent-button': 'Créer un agent',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Voulez-vous vraiment supprimer cet agent ? Cette action est irréversible.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Supprimer « {agentName} » ?',
  'ai-mate.agent-list.delete-agent-error': "Impossible de supprimer l'agent",
  'ai-mate.agent-list.delete-agent-error.agent-in-use': "L'agent est en cours d'utilisation. Réessayez ultérieurement.",
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Impossible de trouver cet agent.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    "Vous ne pouvez pas supprimer des agents que vous n'avez pas vous-même créés. Veuillez contacter le propriétaire de l'agent.",
  'ai-mate.agent-list.delete-agent-success': "L'agent a été supprimé !",
  'ai-mate.agent-list.public-agents-title': 'Agents publics',
  'ai-mate.agent-list.show-hide-label': 'Afficher/Masquer {agentName}',
  'ai-mate.agent-list.system-agents-title': 'Agents Atlassian',
  'ai-mate.agent-list.title': 'Découvrir et gérer les agents',
  'ai-mate.agent-message.error': 'Recharger le chat',
  'ai-mate.agent-message.general-error': 'Oups. Nous avons rencontré une erreur.',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Annuler',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Supprimer',
  'ai-mate.agent-picker.dropdown-item.agents-dropdown-group-title': 'Des agents qui peuvent vous aider',
  'ai-mate.agent-picker.dropdown-item.chat-history': 'Historique du chat',
  'ai-mate.agent-picker.dropdown-item.create': 'Créer un agent',
  'ai-mate.agent-picker.dropdown-item.debug-mode': 'Déboguer le mode',
  'ai-mate.agent-picker.dropdown-item.list': 'Rechercher des agents',
  'ai-mate.agent-picker.dropdown-item.submit-feedback': 'Envoyer du feedback',
  'ai-mate.agent-picker.dropdown-trigger-label': 'Sélectionner un agent',
  'ai-mate.agent-picker.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} ne peut pas dépasser {maxLength,number} caractère} other {{fieldName} ne peut pas dépasser {maxLength,number} caractères}}',
  'ai-mate.agent-popup.create-agent-button': 'Créer un agent',
  'ai-mate.agent-popup.manage-agents-button': 'Gérer les agents',
  'ai-mate.agent-popup.modal-title': "Configuration de l'agent",
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.cameo-dropdown.trigger-label': 'Sélectionner un agent',
  'ai-mate.chat-history.empty-state.brand-name': 'Chat',
  'ai-mate.chat-history.empty-state.message':
    'Obtenez des réponses, générez de nouvelles idées et accélérez le travail quotidien. Rédigez une invite pour vous lancer.',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': 'Annuler',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': 'Confirmer',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button':
    'Un problème est survenu lors de la réalisation de cette action',
  'ai-mate.chat-input.actions-button.label': 'Insérer des éléments',
  'ai-mate.chat-input.cameo-agent-talking-to': 'Vous parlez avec {agentName}',
  'ai-mate.chat-input.placeholder':
    'Saisissez une invite, @mentionnez une personne ou utilisez / pour réaliser des actions',
  'ai-mate.chat-input.send-button.label': 'Envoyer',
  'ai-mate.chat-input.start-recording-button.label': 'Lancer la reconnaissance vocale',
  'ai-mate.chat-input.stop-generating-button.label': 'Arrêter la génération',
  'ai-mate.chat-input.stop-recording-button.label': 'Arrêter la reconnaissance vocale',
  'ai-mate.chat-input.store-user-messages.label':
    'Enregistrez ce message pour nous aider à améliorer la qualité des réponses',
  'ai-mate.chat-view.back-button.label': 'Retour',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Supprimer',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Renommer',
  'ai-mate.chat-view.chat-item.options-button-label': 'Options de chat',
  'ai-mate.chat-view.close-chat-button.label': 'Fermer le chat',
  'ai-mate.chat-view.header-title': 'Historique du chat',
  'ai-mate.chat-view.new-chat-button.label': 'Nouveau chat',
  'ai-mate.chat-view.no-chat': 'Aucun résultat',
  'ai-mate.chat-view.search-input.placeholder': 'Recherchez des chats',
  'ai-mate.content-renderer.profile-card.view-profile-button': 'Afficher le profil',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Annuler',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    "La conversation que vous essayez de supprimer n'existe pas.",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Supprimer',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Supprimer la conversation « {name} » ?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    "Une erreur s'est produite lors de la suppression de cette conversation. Veuillez réessayer.",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Voulez-vous vraiment supprimer cette conversation ? Cette action est irréversible.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Annuler',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    "Le canal que vous essayez de modifier n'existe pas.",
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Nom',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    "Une erreur s'est produite lors de la modification de cette conversation. Veuillez réessayer.",
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Modifier la conversation',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Le nom est le même que le nom actuel.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Enregistrer',
  'ai-mate.expander.hide-details': 'Masquer les informations',
  'ai-mate.expander.show-details': "Afficher plus d'informations",
  'ai-mate.footer.beta': 'BÊTA',
  'ai-mate.footer.info': 'La qualité du contenu est susceptible de varier',
  'ai-mate.footer.rovo-branding-label': 'Rovo {logo}',
  'ai-mate.main-chat.close-chat-button-label': 'Fermer',
  'ai-mate.main-chat.maximize-chat-button-label': 'Plein écran',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restaurer la vue',
  'ai-mate.main-chat.new-chat-button-label': 'Nouveau',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nouveau chat',
  'ai-mate.main-panel.failed-to-load-agents': 'Échec de la récupération des agents',
  'ai-mate.message-renderer.error': 'Contactez-nous si le problème persiste.',
  'ai-mate.message-renderer.error-title': 'Échec du chargement du contenu',
  'chat-history.rate-limit-warning':
    '{secondsRemaining, plural, one {Veuillez patienter {secondsRemaining,number} seconde} other {Veuillez patienter {secondsRemaining,number} secondes}}',
  'chat-history.rate-limit-warning-description': 'Les messages sont envoyés trop vite, veuillez patienter.',
  'chatHistory.storeAssistant.badResponseLabel': 'Mauvaise réponse',
  'chatHistory.storeAssistant.copyResponseLabel': 'Copier',
  'chatHistory.storeAssistant.goodResponseLabel': 'Bonne réponse',
  'rovo-chat.store-assistant.insert-replace.insert-button-label': 'Insérer dans la page',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': 'Remplacer la sélection',
};
